/**
 * 支援者向け PDF 領収書および Books & Rules / キャンペーン機能の日本語コピー
 * (`@gamecodex/world-ui` → `features/books`)
 *
 * キーは機能の React コンポーネント内の `t('books.*')` 呼び出しを反映します。値は
 * i18n スイープ時に抽出された正確な日本語文字列です。
 */
export const booksJa = {
  // BackerDownloadModal.tsx
  'books.backerModal.title': '支援者 PDF を受け取る',
  'books.backerModal.sendLinkError': '現在、サインインリンクを送信できません。しばらくしてからもう一度お試しください。',
  'books.backerModal.checkInboxPrefix': 'メール受信箱を確認してください',
  'books.backerModal.checkInboxSuffix':
    'そのメールアドレスで支援された場合は、サインインリンクが届きます。クリックしてコピーを受け取ってください。',
  'books.backerModal.linkAutoSignIn': 'リンクはこのサイトで開き、自動的にサインインします。パスワードは不要です。',
  'books.backerModal.signInIntro':
    '支援時に使用したメールアドレスを入力してください。ワンクリックのサインインリンクを送信した後、あなたの個人用コピーを準備します。',
  'books.backerModal.pledgeEmailLabel': '支援アカウントのメールアドレス',
  'books.backerModal.emailLinkCta': 'サインインリンクをメール送信',
  'books.backerModal.prepareTimeout':
    'コピーの準備に予想より長い時間がかかっています。数分後にもう一度お試しください。',
  'books.backerModal.notEntitled': 'サインイン済みですが、お客様の支援にはこの本が含まれていません。',
  'books.backerModal.notClaimable': 'この本は支援者ダウンロードとしてはご提供されていません。',
  'books.backerModal.prepareError': '現在、ダウンロードの準備ができません。しばらくしてからもう一度お試しください。',
  'books.backerModal.signedInAs': 'サインイン中',
  'books.backerModal.signOut': 'サインアウト',
  'books.backerModal.verified': '確認済み',
  'books.backerModal.welcomeBack': ' — おかえりなさい、',
  'books.backerModal.backerNumber': '（支援者 #{number}）',
  'books.backerModal.copyReady':
    'お客様の個人用コピーの準備ができました。このリンクは個人用で、まもなく無効になります。共有しないでください。',
  'books.backerModal.downloadPdf': 'PDF をダウンロード',
  'books.backerModal.dtrpgEmailLabel': 'DriveThruRPG アカウントのメールアドレス',
  'books.backerModal.optional': '（オプション）',
  'books.backerModal.dtrpgWarn':
    '指定すると、購入を DriveThruRPG ライブラリにミラーリングします。スキップしても、ここからコピーをダウンロードできます。',
  'books.backerModal.preparingCopy': 'コピーを準備中…',
  'books.backerModal.prepareDownload': '準備 & ダウンロード',

  // BackerVerifyPage.tsx
  'books.backerVerify.missingToken': 'このサインインリンクにはトークンが含まれていません。本のページから新しいリンクをリクエストしてください。',
  'books.backerVerify.invalidToken':
    'このサインインリンクは無効であるか、有効期限が切れています。本のページから新しいものをリクエストしてください。',
  'books.backerVerify.seoTitle': '支援者サインイン',
  'books.backerVerify.seoDescription': 'Grymwyrd 支援者サインインリンクの確認中です。',
  'books.backerVerify.confirming': '支援者サインインを確認中…',
  'books.backerVerify.signedInHeading': 'サインイン済みです',
  'books.backerVerify.signedInAs': 'サインイン中',
  'books.backerVerify.headBackPrefix': '本に戻り、',
  'books.backerVerify.downloadWord': 'ダウンロード',
  'books.backerVerify.headBackSuffix': 'をクリックしてコピーを受け取ってください。',
  'books.backerVerify.backToBook': 'この本に戻る',
  'books.backerVerify.browseAthenaeum': 'アテネウム を閲覧',
  'books.backerVerify.problemHeading': 'サインインリンクに問題があります',

  // BookCard.tsx
  'books.card.viewAria': '{title} を表示',
  'books.card.coverAlt': '{title} の表紙',
  'books.card.owned': '所有中',

  // BookCover.tsx
  'books.cover.coverAlt': '{title} の表紙',

  // BookStorePage.tsx
  'books.store.seoTitle': 'Books & Rules',
  'books.store.seoDescription':
    '永劫の黄昏の史書 — コアルールブック、イラスト入り SRD、ダークファンタジー冒険譚。購入してモジュールを解除し、コインを獲得しましょう。',
  'books.store.eyebrow': 'アテネウム',
  'books.store.heading': 'Books & Rules',
  'books.store.intro':
    '世界を結ぶ史書を手に入れます。すべての購入により、キャンペーン内でプレイ可能なモジュールが解除され、世界の経済圏でのコインが贈呈されます。',
  'books.store.filterAria': '本のタイプでフィルタリング',
  'books.store.filterAll': 'すべて',
  'books.store.loading': '文庫を開封中…',
  'books.store.empty': 'このカテゴリーに該当する史書はまだありません。筆記者が作業中です。',

  // BuyButton.tsx
  'books.buy.checkoutUnavailable': 'チェックアウトはまだ利用できません。もう一度お試しください。',
  'books.buy.signInToClaim': 'この史書を受け取るにはサインインしてください。',
  'books.buy.ledgerSealed': '商人の帳簿は現在封鎖されています。チェックアウトはまもなく利用可能になります。',
  'books.buy.inLibrary': '所有ライブラリ',
  'books.buy.openingVault': '金庫を開けています…',
  'books.buy.claimFree': '無料で受け取る',
  'books.buy.buyPrice': '購入 — {price}',
  'books.buy.unlockPrefix': '購入 → モジュール解除 +',
  'books.buy.coinsSuffix': '{coins} コイン',

  // BookDetailPage.tsx
  'books.detail.loading': 'ページをめくっています…',
  'books.detail.backToAthenaeum': 'アテネウム に戻る',
  'books.detail.unlockOwned': 'この史書を所有しています。Grymwyrd の知識は事典全体で解除されます。',
  'books.detail.unlockClaim': 'この史書を受け取り、Grymwyrd の知識を事典全体で解除します。',
  'books.detail.returnTo': '{label} に戻る',
  'books.detail.backerCta': '支援者ですか？PDF をダウンロード',
  'books.detail.coinsEarned': 'この購入により {coins} コインを獲得しました。',
  'books.detail.coinsGranted': '購入により {coins} コインが与えられます。',
  'books.detail.byAuthor': '{author} 著',
  'books.detail.statPrice': '価格',
  'books.detail.statPages': 'ページ数（最終レンダリング）',
  'books.detail.statWords': 'ワード数（最終レンダリング）',
  'books.detail.ofThisTome': 'この史書について',
  'books.detail.noDescription': 'この巻についての説明はまだ記述されていません。',
  'books.detail.previewHeading': 'プレビュー',
  'books.detail.previewBlurb': 'この史書を受け取る前に、サンプルを一目見てください。',
  'books.detail.readPreview': 'プレビューを読む',
  'books.detail.tocHeading': ' 目 次',
  'books.detail.tocEmpty': 'この史書の内容はまだカタログ化されていません。',
  'books.detail.pageAbbrev': 'p. {page}',
  'books.detail.unlockedHeading': '解除された事典エントリ',
  'books.detail.unlockedOwnedNote': 'これで生きた事典の一部になりました：',
  'books.detail.unlockedLockedNote':
    'この史書を購入して、その生物、呪文、秘密を事典に記載し、',
  'books.detail.coinsAmount': '{coins} コイン',
  'books.detail.attributionsHeading': 'クレジット & ライセンス',
  'books.detail.attributionSource': '出典',
  'books.detail.attributionLink': 'リンク',

  // CampaignLandingPage.tsx
  'books.campaign.liveCampaign': 'ライブキャンペーン',
  'books.campaign.backThisProject': 'このプロジェクトを支援',
  'books.campaign.viewStretchGoals': 'ストレッチゴールを表示',
  'books.campaign.pledged': 'クラウドファンディング額',
  'books.campaign.backers': '支援者',
  'books.campaign.pitchHeading': 'ピッチ',
  'books.campaign.backerUnlockedHeading': '支援者限定エントリ',
  'books.campaign.backerUnlockedBlurb':
    '支援者は、生きた事典に直接流入するコンテンツに早期アクセスできます。既にカノンに組み込まれている内容の一部をここに示します：',
  'books.campaign.previewsEmpty': '新しいカノンが記述されています。ゴールがアンロックされたら確認してください。',
  'books.campaign.choosePledge': '支援内容を選択',
  'books.campaign.mostBacked': '最も支援された',
  'books.campaign.pledgeAmount': '{amount} で支援',
  'books.campaign.pledgeFooter':
    '支援はチェックアウトで安全に処理されます。支援特典（コイン、モジュール、事典ロック解除）は、キャンペーンサービスがライブになったら Grymwyrd アカウントに付与されます。',

  // LanguageSelect.tsx
  'books.language.label': '言語',

  // PreviewModal.tsx
  'books.preview.title': 'プレビュー — {title}',
  'books.preview.pdfAria': '{title} のプレビュー PDF',
  'books.preview.cannotDisplay': 'お使いのブラウザでプレビューをインラインで表示できません。',
  'books.preview.openNewTab': 'プレビューを新しいタブで開く',
  'books.preview.preparingHeading': 'プレビューが準備されています。',
  'books.preview.preparingBody':
    'この史書のサンプルが筆記所によって記述中で、まもなくここに表示されます。その間に、内容をご覧ください：',
  'books.preview.excerptLabel': '抜粋 — {title}',
  'books.preview.excerptFallback':
    'この先の先には、恐怖と驚嘆に浸った ページが広がっています。史書を獲得して読み進めてください。',
  'books.preview.noExcerpt': 'この巻についての抜粋はまだカタログ化されていません。',

  // RulesPage.tsx
  'books.rules.sectionSpells': '呪文',
  'books.rules.sectionMonsters': 'モンスター',
  'books.rules.sectionMagicItems': '魔法のアイテム',
  'books.rules.sectionWeapons': '武器',
  'books.rules.sectionArmor': '防具',
  'books.rules.sectionSkills': 'スキル',
  'books.rules.entriesCount': '{entries} エントリ',
  'books.rules.readingLabel': '{label} を読み込み中…',
  'books.rules.noneCatalogued': 'このシステムでは {label} はまだカタログ化されていません。',
  'books.rules.browseAll': '事典ですべての {label} を閲覧 →',
  'books.rules.seoTitle': 'ルール & SRD',
  'books.rules.seoDescription':
    'System Reference Document を閲覧してください。呪文、モンスター、アイテム、および永劫の黄昏を縛るルール。今は 5e SRD で、他のシステムも近日対応予定です。',
  'books.rules.eyebrow': 'コデックス',
  'books.rules.heading': 'ルール & System Reference',
  'books.rules.intro':
    'Grymwyrd を動かすオープンゲームコンテンツ。ルール関連のエントリを閲覧し、完全な事典に飛び込んで stat blocks とロアを掘り下げてください。Grymwyrd は今日 5e SRD をサポートしています。PF2e および他のシステムはまもなく対応予定です。',
  'books.rules.loading': 'コデックスを参照中…',
  'books.rules.gameSystems': 'ゲームシステム',
  'books.rules.noSystems': 'ゲームシステムはまだ登録されていません。',
  'books.rules.openSrd': 'SRD を開く',
  'books.rules.lockedComingSoon': 'ロック中 — まもなく対応',
  'books.rules.referenceContent': '{name} — リファレンスコンテンツ',
  'books.rules.releasedUnder': '{license} でリリース',
  'books.rules.licenseLink': 'ライセンス',

  // StretchGoals.tsx
  'books.stretch.goalProgressAria': '{title} ファンディング進捗',
  'books.stretch.unlockedAdded': 'ロック解除 — 事典に追加されました',
  'books.stretch.percentFunded': '{pct}% 達成',
  'books.stretch.autoPopulates': '事典に自動入力',
  'books.stretch.raisedSoFar': 'これまでの調達額',
  'books.stretch.backers': '支援者',
  'books.stretch.overallAria': '全体のキャンペーン資金調達',
  'books.stretch.heading': 'ストレッチゴール',
}
